import { AbstractMap3sqd8xvg0030s as AbstractMap } from './AbstractMap.mjs';
import {
  HashMapKeysDefaultd8xopyn6vbgh as HashMapKeysDefault,
  HashMapValuesDefault3j1xghpfb6bpq as HashMapValuesDefault,
} from './HashMapEntryDefault.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractMutableMapClass;
function AbstractMutableMap() {
  if (AbstractMutableMapClass === VOID) {
    class $ extends AbstractMap() {
      static n7() {
        var $this = this.q7();
        $this.l7_1 = null;
        $this.m7_1 = null;
        return $this;
      }
      r7() {
        return HashMapKeysDefault().t7(this);
      }
      u7() {
        return HashMapValuesDefault().w7(this);
      }
      q3() {
        var tmp0_elvis_lhs = this.l7_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.r7();
          this.l7_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      r3() {
        var tmp0_elvis_lhs = this.m7_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.u7();
          this.m7_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      v3() {
        this.d2().v3();
      }
      u3(from) {
        this.k6();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = from.d2().m1();
        while (_iterator__ex2g4s.n1()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.o1();
          // Inline function 'kotlin.collections.component1' call
          var key = _destruct__k2r9zo.e2();
          // Inline function 'kotlin.collections.component2' call
          var value = _destruct__k2r9zo.f2();
          this.s3(key, value);
        }
      }
      t3(key) {
        this.k6();
        var iter = this.d2().m1();
        while (iter.n1()) {
          var entry = iter.o1();
          var k = entry.e2();
          if (equals(key, k)) {
            var value = entry.f2();
            iter.l6();
            return value;
          }
        }
        return null;
      }
      k6() {
      }
    }
    initMetadataForClass($, 'AbstractMutableMap', VOID, VOID, [AbstractMap(), KtMutableMap()]);
    AbstractMutableMapClass = $;
  }
  return AbstractMutableMapClass;
}
//region block: exports
export {
  AbstractMutableMap as AbstractMutableMapyktux9ubhc1g,
};
//endregion

//# sourceMappingURL=AbstractMutableMap.mjs.map
